import React, { Component } from 'react';
import { func, arrayOf, shape, string } from 'prop-types';
import { components as reactSelectComponents } from 'react-select';
import Select from 'ps-components/ReactSelect/ReactSelect';
import { connect } from 'react-redux';
import { CustomDropdownIndicator } from './CustomDropdownIndicator';

import './Select.scss';

const SingleValue = ({ ...props }) => {
  return (
    <reactSelectComponents.SingleValue {...props}>
      <div className="react-select__logo-container">
        <img className="react-select__logo" src={props.data.logo} alt={props.data.name} />
      </div>
    </reactSelectComponents.SingleValue>
  );
};

class SubsiteSelect extends Component {
  static propTypes = {
    dispatch: func,
    organization: shape({
      code: string.isRequired,
      name: string.isRequired,
      logo: string
    }).isRequired,
    organizations: arrayOf(
      shape({
        code: string.isRequired,
        name: string.isRequired
      })
    ).isRequired
  };

  constructor(props) {
    super(props);
    this.goToSubsite = this.goToSubsite.bind(this);
  }

  goToSubsite(selectedOption) {
    const url = `/view/o/${selectedOption.code}/mp/`;
    window.location.href = url;
  }

  sortByOrgName(first, second) {
    const firstSubsite = first.name.toUpperCase();
    const secondSubsite = second.name.toUpperCase();

    if (firstSubsite < secondSubsite) {
      return -1;
    }

    if (firstSubsite > secondSubsite) {
      return 1;
    }

    return 0;
  }

  render() {
    if (!this.props.organization) return null;
    const { organizations, organization } = this.props;

    let options = organizations;
    if (organizations && organizations.length > 1) {
      options = [...organizations].sort(this.sortByOrgName);
    }

    return (
      <div className="select">
        <Select
          ref={subsiteSelect => (this.subsiteSelect = subsiteSelect)}
          options={options}
          getOptionLabel={({ name }) => name}
          getOptionValue={({ code }) => code}
          clearable={false}
          onChange={this.goToSubsite}
          className="react-select-subsite-container"
          classNamePrefix="react-select"
          instanceId="subsite-select"
          value={organization}
          components={{ SingleValue, DropdownIndicator: CustomDropdownIndicator }}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    organizations: state.organizations,
    organization: state.session.organization
  };
};

export default connect(mapStateToProps)(SubsiteSelect);
